import React from "react"
import DateHelper from "../../DateHelper/DateHelper"
import {isAfter} from 'date-fns'

class HoldStatusDataType extends React.Component{
	constructor(props) {
		super(props);
	}

	render() {
		var check_out_date = DateHelper.parseDate(this.props.row.check_out_date);
		var todaysDate = DateHelper.today()
		var passed_check_out = isAfter(todaysDate, check_out_date)

    if (this.props.row.status == 'canceled') {
      return (
        <div style={{ color: 'red' }}>{I18n.t('canceled')}</div>
      );
    }
    else if (passed_check_out){
      return (
        <div>
          <div>{I18n.t('expired')}</div>
        </div>
      );
    }
    else if(this.props.row.status == 'held') {
      return (
        <div style={{ color: 'green' }}>{I18n.t('active') }</div>
      );
    }  
	};
};

export default HoldStatusDataType
